// (function() {
// 	'use strict';
// 	window.addEventListener(
// 		'load',
// 		function() {
// 			// Fetch all the forms we want to apply custom Bootstrap validation styles to
// 			var forms = document.getElementsByClassName('needs-validation');

// 			// Loop over them and prevent submission
// 			var validation = Array.prototype.filter.call(forms, function(form) {
// 				form.addEventListener(
// 					'submit',
// 					function(event) {
// 						//event.preventDefault();
// 						form.querySelector('button[type="submit"]').disabled = true;
// 						if (form.checkValidity() === false) {
// 							event.preventDefault();
// 							event.stopPropagation();
// 							form.querySelector('button[type="submit"]').disabled = false;
// 						}
// 						form.classList.add('was-validated');
// 					},
// 					false
// 				);
// 			});
// 		},
// 		false
// 	);
// })();

// (function() {
// 	$('form.needs-validation').each(function() {
// 		var $form = $(this);
// 		$form.on('submit', function(e) {
// 			$form.find('button[type="submit"]').prop('disabled', true);
// 			if ($form[0].checkValidity() === false) {
// 				e.preventDefault();
// 				e.stopPropagation();
// 				$form.find('button[type="submit"]').prop('disabled', false);
// 			} else {
// 				$form.find('button[type="submit"]').text('Processing');
// 			}
// 			$form.addClass('was-validated');
// 		});
// 	});
// })();

import Btn from './btn';

const func = () => {
	$('form.needs-validation').each(function() {
		var $form = $(this),
			$btn = new Btn($form.find('button[type="submit"]')),
			$kd45 = $('[data-kd-id="045"]'),
			$checkboxRequired = $form.find('.checkbox-group.required'),
			scrollPos = 0;

		$form.on('submit', function(e) {
			$btn.disable();

			if ($form[0].checkValidity() === false) {
				e.preventDefault();
				e.stopImmediatePropagation();
				$btn.enable();
				scrollPos = $form
					.find(':invalid')
					.eq(0)
					.parents('.form-group')
					.offset().top;
				// window.scroller.animateScroll(Number(scrollPos) - Number($('header').outerHeight() + ($kd45[0] ? $kd45.outerHeight() : 0)));
				window.scroller.animateScroll(Number(scrollPos) - Number(($kd45[0] ? $kd45.outerHeight() : 0)));
			} else {
				scrollPos = 0;
				$btn.process();
			}
			$form.addClass('was-validated');

			// Checkbox group validation
			if($checkboxRequired[0]) {

				$checkboxRequired.each(function() {

					var $this = $(this), 
						$checkboxes = $this.find(':checkbox'),
						tickedCheckboxes = $this.find(':checkbox:checked').length,
						$invalidFeedback = $this.find('.invalid-feedback');

					$checkboxes.change(function() {
						if($this.find(':checkbox:checked').length === 0) {
							$invalidFeedback.show();
						} else {
							$invalidFeedback.hide();
						}
					});

					if(tickedCheckboxes == 0) {
						e.preventDefault();
						e.stopImmediatePropagation();
						$invalidFeedback.show();
						$btn.enable();
						$btn.processed();
						var checkboxGroupScrollPos = $this
							.eq(0)
							.offset().top;				

						if((scrollPos === 0) || (scrollPos > checkboxGroupScrollPos)) {
							// window.scroller.animateScroll(Number(checkboxGroupScrollPos) - Number($('header').outerHeight() + ($kd45[0] ? $kd45.outerHeight() : 0)));
							window.scroller.animateScroll(Number(checkboxGroupScrollPos) - Number(($kd45[0] ? $kd45.outerHeight() : 0)));
						}

					} else {
						$invalidFeedback.hide();
					}

				});

			}

		});
	});
};

export default func;
